import { CrmOpportunityWorkbenchFeaturePage } from "../ui/CrmOpportunityWorkbenchFeaturePage";

/** CRM 商机工作台路由页面。 */
export function CrmOpportunityWorkbenchPage() {
  return <CrmOpportunityWorkbenchFeaturePage />;
}
